export function resolveSharedChatAuthorTitle(params: {
	actorType: string
	authorTitle: string | null
	deletedUserLabel: string
	aiAuthorLabel: string
}): string {
	if (params.actorType === "ai") return params.aiAuthorLabel
	return params.authorTitle ?? params.deletedUserLabel
}
